import { LlmModelName } from 'notable-common';
import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
const ExtractableEntitySchema = z.object({
    name: z.string().min(1, 'Field name is required and cannot be empty'),
    description: z.string().default(''),
});
const ExtractionExampleSchema = z.object({
    input: z.string().default(''),
    output: z.string().default(''),
});
const FlowInformationExtractionBlockConfigSchema = z.object({
    documents: z.string().min(1, 'Input documents are required'),
    extractionFields: z
        .array(ExtractableEntitySchema)
        .min(1, 'At least one extraction field must be defined'),
    examples: z.array(ExtractionExampleSchema).optional().default([]),
    additionalPrompt: z.string().optional(),
    rankingPrompt: z.string().optional(),
    modelName: z.enum(LlmModelName).default(LlmModelName.notable_default),
});
export const FlowInformationExtractionBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.InformationExtraction),
    config: FlowInformationExtractionBlockConfigSchema,
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.Any),
});
//# sourceMappingURL=config.js.map